import { Role } from '@app/shared/models/role';
import { User } from '@app/shared/models/user';
import { createAction, props } from '@ngrx/store';
import { GetMetricStatisticInput } from '@smash-sdk/transfer/ejs/01-2024';

// Load Members
export const loadMembers = createAction(
  '[TeamMembers] Load Members',
  props<{ teamId: string }>()
);

export const loadMembersSuccess = createAction(
  '[TeamMembers] Load Members Success',
  props<{ members: User[] }>()
);

export const loadMembersFailure = createAction(
  '[TeamMembers] Load Members Failure',
  props<{ error: any }>()
);

// Account Members
export const LoadAccountMembers = createAction(
  '[TeamMembers] Load Account Members',
);

export const LoadAccountMembersSuccess = createAction(
  '[TeamMembers] Load Account Members Success',
  props<{ members: User[] }>()
);

export const LoadAccountMembersFailure = createAction(
  '[TeamMembers] Load Account Members Failure',
  props<{ error: any }>()
);

// Load Member Roles
export const loadMemberRoles = createAction(
  '[TeamMembers] Load Member Roles',
  props<{ teamId: string, userId: string }>()
);

export const loadMemberRolesSuccess = createAction(
  '[TeamMembers] Load Member Roles Success',
  props<{ roles: Role[], attributableRoles: Role[] }>()
);

export const loadMemberRolesFailure = createAction(
  '[TeamMembers] Load Member Roles Failure',
  props<{ error: any }>()
);

// Load Member Groups
export const loadMemberGroups = createAction(
  '[TeamMembers] Load Member Groups',
  props<{ teamId: string, userId: string }>()
);

export const loadMemberGroupsSuccess = createAction(
  '[TeamMembers] Load Member Groups Success',
  props<{ groups: any[], attributableGroups: any[] }>()
);

export const loadMemberGroupsFailure = createAction(
  '[TeamMembers] Load Member Groups Failure',
  props<{ error: any }>()
);

export const resetCreation = createAction(
  '[TeamMembers] Reset Creation Member',
);

export const loadMember = createAction(
  '[TeamMembers] Load Member',
  props<{ teamId: string, userId: string }>()
);

export const loadMemberSuccess = createAction(
  '[TeamMembers] Load Member Success',
  props<{ member: User }>()
);

export const loadMemberFailure = createAction(
  '[TeamMembers] Load Member Failure',
  props<{ error: any }>()
);

export const updateMember = createAction(
  '[TeamMembers] Update Member',
  props<{ teamId: string, data: any }>()
);

export const updateMemberSuccess = createAction(
  '[TeamMembers] Update Member Success',
  props<{ member: User }>()
);

export const updateMemberFailure = createAction(
  '[TeamMembers] Update Member Failure',
  props<{ error: any }>()
);

// Add Member
export const addMember = createAction(
  '[TeamMembers] Add Member',
  props<{
    teamId: string,
    member: User,
    lastName: string,
    firstName: string,
    invited: boolean,
    role: Role,
    authenticationMode: 'SSO' | 'Standard',
  }>()
);

export const addMemberSuccess = createAction(
  '[TeamMembers] Add Members Success',
  props<{ member: any }>()
);

export const addMemberFailure = createAction(
  '[TeamMembers] Add Members Failure',
  props<{ error: any }>()
);

// Import Members
export const initImportMembers = createAction(
  '[TeamMembers] Init Import Members',
  props<{ teamId: string, fileMembers: File[], csvContent: string }>()
);

export const checkContentFile = createAction(
  '[TeamMembers] Check Content File',
  props<{ teamId: string, fileMembers: File[], csvContent: string }>()
);

export const checkContentFileSuccess = createAction(
  '[TeamMembers] Check Content File Success',
);

export const checkContentFileFailure = createAction(
  '[TeamMembers] Check Content File Failure',
  props<{ error: any }>()
);

export const importMembers = createAction(
  '[TeamMembers] Import Members',
  props<{ teamId: string, members: any[] }>()
);

export const importMembersSuccess = createAction(
  '[TeamMembers] Import Members Success',
  props<{ members: any[], nonBlockingError?: any }>()
);

export const importMembersFailure = createAction(
  '[TeamMembers] Import Members Failure',
  props<{ error: any }>()
);

export const UpdateImportMembersStatus = createAction(
  '[TeamMembers] Update Import Members Status',
  props<{ importedMembers: any[] }>()
);

export const resetImportMembers = createAction(
  '[TeamMembers] Reset Import Members',
);

// Attach member to team
export const attachMemberToTeam = createAction(
  '[TeamMembers] Attach Member',
  props<{ member: User, team: any, role: any }>()
);

export const attachMemberToTeamSuccess = createAction(
  '[TeamMembers] Attach Members Success'
);

export const attachMemberToTeamFailure = createAction(
  '[TeamMembers] Attach Members Failure',
  props<{ error: any }>()
);

// Detach member from team
export const detachMemberFromTeam = createAction(
  '[TeamMembers] Detach Member',
  props<{ member: User, team: any }>()
);

export const detachMemberFromTeamSuccess = createAction(
  '[TeamMembers] Detach Members From Team Success'
);

export const detachMemberFromTeamFailure = createAction(
  '[TeamMembers] Detach Members From Team Failure',
  props<{ error: any }>()
);

// Attach member to group
export const attachMemberToGroup = createAction(
  '[TeamMembers] Attach Member To Group',
  props<{ teamId: string, member: any, group: any }>()
);

export const attachMemberToGroupSuccess = createAction(
  '[TeamMembers] Attach Members To Group Success'
);

export const attachMemberToGroupFailure = createAction(
  '[TeamMembers] Attach Members To Group Failure',
  props<{ error: any }>()
);

// Attach role to Member
export const attachRoleToMember = createAction(
  '[TeamMembers] Attach Role To Member',
  props<{ teamId: string, userId: string, role: Role }>()
);

export const attachRoleToMemberSuccess = createAction(
  '[TeamMembers] Attach Role To Member Success'
);

export const attachRoleToMemberFailure = createAction(
  '[TeamMembers] Attach Role To Member Failure',
  props<{ error: any }>()
);

// Detach member from group
export const detachMemberFromGroup = createAction(
  '[TeamMembers] Detach Role From Member',
  props<{ teamId: string, member: User, group: any }>()
);

export const detachMemberFromGroupSuccess = createAction(
  '[TeamMembers] Detach Role From Member Success'
);

export const detachMemberFromGroupFailure = createAction(
  '[TeamMembers] Detach Role From Member Failure',
  props<{ error: any }>()
);

// Detach role from member
export const detachRoleFromMember = createAction(
  '[TeamMembers] Detach Role From Member',
  props<{ teamId: string, userId: string, role: Role }>()
);

export const detachRoleFromMemberSuccess = createAction(
  '[TeamMembers] Detach Role From Member Success'
);

export const detachRoleFromMemberFailure = createAction(
  '[TeamMembers] Detach Role From Member Failure',
  props<{ error: any }>()
);

// Load attributable roles
export const loadTeamRoles = createAction(
  '[TeamMembers] Load Team Roles',
  props<{ teamId: string }>()
);

export const loadTeamRolesSuccess = createAction(
  '[TeamMembers] Load Team Roles Success',
  props<{ roles: any }>()
);

export const loadTeamRolesFailure = createAction(
  '[TeamMembers] Load Team Roles Failure',
  props<{ error: any }>()
);

// Load attributable groups
export const loadAttributableGroups = createAction(
  '[TeamMembers] Load Attributable Groups',
);

export const loadAttributableGroupsSuccess = createAction(
  '[TeamMembers] Load Attributable Groups Success',
  props<{ groups: any[] }>()
);

export const loadAttributableGroupsFailure = createAction(
  '[TeamMembers] Load Attributable Groups Failure',
  props<{ error: any }>()
);

export const deleteMember = createAction(
  '[TeamMembers] Delete Member',
  props<{ teamId: string, member: User }>()
);

export const deleteMemberSuccess = createAction( // Response ?
  '[TeamMembers] Delete Member Success',
);

export const deleteMemberFailure = createAction(
  '[TeamMembers] Delete Member Failure',
  props<{ error: any }>()
);

export const inviteMember = createAction(
  '[TeamMembers] Invite Member',
  props<{ teamId: string, userId: string }>()
)

export const inviteMemberSuccess = createAction(
  '[TeamMembers] Invite Member Success'
)

export const inviteMemberFailure = createAction(
  '[TeamMembers] Invite Member Failure',
  props<{ error: any }>()
)

export const switchMemberRole = createAction(
  '[TeamMembers] Switch Member Role',
  props<{ member: User, roleToDettach: any, roleToAttach: any }>()
);

export const switchMemberRoleSuccess = createAction(
  '[TeamMembers] Switch Member Role Success'
);

export const switchMemberRoleFailure = createAction(
  '[TeamMembers] Switch Member Role Failure',
  props<{ error: any }>()
);

// Root role
export const addRootRoleToMember = createAction(
  '[TeamMembers] Add Root Role',
  props<{ member: User }>()
);

export const addRootRoleToMemberSuccess = createAction(
  '[TeamMembers] Add Root Role Success'
);

export const addRootRoleToMemberFailure = createAction(
  '[TeamMembers] Add Root Role Failure',
  props<{ error: any }>()
);

export const removeRootRoleFromMember = createAction(
  '[TeamMembers] Remove Root Role',
  props<{ member: User }>()
);

export const removeRootRoleFromMemberSuccess = createAction(
  '[TeamMembers] Remove Root Role Success'
);

export const removeRootRoleFromMemberFailure = createAction(
  '[TeamMembers] Remove Root Role Failure',
  props<{ error: any }>()
);

// Counter

export const loadMemberTransferCount = createAction(
  '[TeamMembers] Load Member Transfer Count',
  props<{ teamId: string, user: string, period: string, unit: GetMetricStatisticInput['unit'] }>()
);

export const loadMemberTransferCountSuccess = createAction(
  '[TeamMembers] Load Member Transfer Count Success',
  props<{ transferCountSeries: any[] }>()
);

export const loadMemberTransferCountFailure = createAction(
  '[TeamMembers] Load Member Transfer Count Failure',
  props<{ error: any }>()
);

export const loadMemberSizeCount = createAction(
  '[TeamMembers] Load Member Size Count',
  props<{ teamId: string, user: string, period: string, unit: GetMetricStatisticInput['unit'] }>()
);

export const loadMemberSizeCountSuccess = createAction(
  '[TeamMembers] Load Member Size Count Success',
  props<{ sizeCountSeries: any[] }>()
);

export const loadMemberSizeCountFailure = createAction(
  '[TeamMembers] Load Member Size Count Failure',
  props<{ error: any }>()
);

export const loadMemberFileCount = createAction(
  '[TeamMembers] Load Member File Count',
  props<{ teamId: string, user: string, period: string, unit: GetMetricStatisticInput['unit'] }>()
);

export const loadMemberFileCountSuccess = createAction(
  '[TeamMembers] Load Member File Count Success',
  props<{ fileCountSeries: any[] }>()
);

export const loadMemberFileCountFailure = createAction(
  '[TeamMembers] Load Member File Count Failure',
  props<{ error: any }>()
);
